import Vue    from 'vue'
import Router from 'vue-router'

import Icon from './components/Icon'

import routes from './routes'
import App    from './App'

import api    from './api'
import './registerServiceWorker'

Vue.use(Router)
Vue.component('Icon', Icon)

Vue.config.productionTip = false

Vue.prototype.$$ = {};
Vue.prototype.$api = api;

new Vue({
  render: h => h(App),
  router: new Router({routes, mode: 'history'}),
}).$mount('#app');

if('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/service-worker.js')
  .then(registration => {
    registration.onupdatefound = function() {
      registration.update();
    }
  })
  .catch();
}

var installPromptEvent;
var btnInstall = document.querySelector('#a2hs');

window.addEventListener('beforeinstallprompt', function(event) {
  event.preventDefault();
  installPromptEvent = event;
  btnInstall.style.display = null;
});

btnInstall.addEventListener('click', function() {
  this.style.display = 'none';
  installPromptEvent.prompt();
});